// extracted by mini-css-extract-plugin
export var avatarContainer = "_8h-0";
export var avatarTypingWave = "_8h-i";
export var gray = "_8h-f";
export var green = "_8h-c";
export var icon = "_8h-9";
export var image = "_8h-1";
export var lg = "_8h-6";
export var md = "_8h-5";
export var presenceDot = "_8h-b";
export var red = "_8h-d";
export var sm = "_8h-4";
export var status = "_8h-a";
export var typingDot = "_8h-h";
export var typingPill = "_8h-g";
export var xl = "_8h-7";
export var xs = "_8h-3";
export var xxl = "_8h-8";
export var xxs = "_8h-2";
export var yellow = "_8h-e";